import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './Menu.js.css';

export class Menu extends Component {
    constructor(props) {
        super(props);
        this.div = document.createElement('div');
        this.div.className = 'menu';
    }

    componentDidMount() {
        const elements = document.getElementsByClassName('mfa-menu');
        if (elements.length > 0) {
            const element = elements[0];
            element.appendChild(this.div);
        }
    }

    componentWillUnmount() {
        const elements = document.getElementsByClassName(this.nomClass);
        if (elements > 0) {
            const element = elements[0];
            element.removeChild(this.div);
        }
    }

    render() {
        const { menus } = this.props;

        return ReactDOM.createPortal(
            <>
                <h4>Dans cette section</h4>
                <hr />
                <ul>
                    {menus.map(menu => {
                        return <li key={menu.nom}><a href={menu.url} target='_blank' rel='noopener noreferrer' >{menu.nom}</a></li>
                    })}
                </ul>
            </>, this.div);
    }
}
